import { useOperadoras } from '../dominio/operadoras.ts';
import { CadastroPorNome } from './CadastroPorNome.tsx';

/**
 * O cadastro de Operadoras, da Administradora (NEX-228).
 *
 * Toda tela que escolhe operadora — venda, implantação, regra de comissão,
 * roteiro, movimentação — lê daqui, e a API recusa nome fora do cadastro.
 * Renomear leva o nome novo a todos os registros que usavam o antigo, porque a
 * regra de comissão casa a venda pelo nome.
 */
export function CadastroDeOperadoras(): React.JSX.Element {
  const { todas, pronta } = useOperadoras();

  return (
    <CadastroPorNome
      titulo="Operadoras"
      descricao="As que aparecem nas vendas, regras de comissão, roteiros e movimentações. Nome fora daqui não é aceito."
      vocabulario={{
        singular: 'operadora',
        plural: 'operadoras',
        uso: ['registro', 'registros'],
        tamanhoMaximo: 120,
      }}
      itens={todas}
      pronto={pronta}
    />
  );
}
